import React from 'react'
import {Slot} from '../deprecated/InputField/slots'

const ChoiceInputLeadingVisual: React.FC = ({children}) => <Slot name="LeadingVisual">{children}</Slot>

export default ChoiceInputLeadingVisual
